import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useHtmlClassService } from "../../_core/Layout";

export function Brand() {
  const uiService: any = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    }
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div
        className={`brand flex-column-auto ${layoutProps.brandClasses}`}
        id="kt_brand"
      >
        {/* begin::Logo */}
        <Link to="/" className="brand-logo">
          <img alt="logo" height={38} src={layoutProps.headerLogo} />
        </Link>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}
    </>
  );
}
